module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/4-48db2ddad7189060af238e9bab24f783.jpg";